import { toast } from "react-toastify";
import api from "../../lib/api";

const apiRoute = `/api/agent/users`;
const agentApiRoute = `/api/agent/users`;
const AGENT_TOKEN_STORAGE_KEY = "agent_token";

export const userProfile = () => (dispatch) => {
  return api
    .get(`${agentApiRoute}/me`)
    .then((user) => {
      const payload = user?.data?.data || user?.data?.user;

      dispatch({
        type: "SET_USER",
        payload,
      });
      if (payload?.role === "agent") {
        dispatch({
          type: "SET_AGENT",
          payload,
        });
      }
      return payload;
    })
    .catch((err) => {
      dispatch({
        type: "SET_USER",
        payload: null,
      });

      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }

      return err;
    });
};

export const logout = (isTrue) => (dispatch) => {
  return api
    .get(`${apiRoute}/logout`)
    .then((res) => {
      dispatch({
        type: "SET_USER",
        payload: {},
      });
      {
        !isTrue && toast.success("Uspešno ste se odlogovali!");
      }
      return res;
    })
    .catch((err) => {
      {
        !isTrue && toast.error("Neuspešno odlogovanje!");
      }
      throw err;
    });
};

export const getAllUsers = () => (dispatch) => {
  return api
    .get(`${apiRoute}`)
    .then((res) => {
      dispatch({
        type: "FETCH_USERS",
        payload: res.data.data,
      });
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
export const agentLogin = (values) => (dispatch) => {
  return api
    .post(`/api/agent/users/login`, values)
    .then((res) => {
      const token = res?.data?.token;
      const user = res?.data?.user || res?.data?.data;

      if (token) {
        try {
          localStorage.setItem(AGENT_TOKEN_STORAGE_KEY, token);
        } catch (e) {
          // ignore storage errors
        }
        // Token is automatically read from localStorage in api.js
      }

      dispatch({
        type: "SET_USER",
        payload: user,
      });
      if (user?.role === "agent") {
        dispatch({
          type: "SET_AGENT",
          payload: user,
        });
      }
      toast.success("Uspešno logovanje!");
      return res;
    })
    .catch((err) => {
      const message = err?.response?.data?.message || "Neuspešno logovanje!";
      toast.error(message);
      return err;
    });
};
